import styled, { css } from "styled-components";

export const Wrapper = styled.div`
    position: relative;
    margin-right: 10px;
    width: 45px;
    display: inline-block;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    text-align: left;

    input {
      display: none;
    }

    > label {
      display: block;
      overflow: hidden;
      cursor: pointer;
      border: 0 solid #bbb;
      border-radius: 20px;
      margin: 0;
      &:focus {
        outline: none;
        > span {
          box-shadow: 0 0 2px 5px red;
        }
      }
      > span:focus {
        outline: none;
      }
    }
    > label > span:nth-child(1) {
      display: block;
      width: 200%;
      margin-left: -100%;
      transition: margin 0.3s ease;
      &:before,
      &:after {
        display: block;
        float: left;
        width: 50%;
        height: 20px;
        padding: 0;
        line-height: 34px;
        font-size: 12px;
        color: var(--white);
        font-weight: bold;
        box-sizing: border-box;
      }
      &:before {
        content: "";
        text-transform: uppercase;
        padding-left: 10px;
        background-color: #2f855a;
        color: #fff;
      }
    }
    > label > span {
      background-color: #ddd;
      &:before {
        background-color: #ddd;
      }
    }
    > label > span:nth-child(1)::after {
      content: "";
      text-transform: uppercase;
      padding-right: 10px;
      background-color: #bbb;
      color: #fff;
      text-align: right;
    }
    > label > span:nth-child(2) {
      display: block;
      width: 12px;
      margin: 5px;
      background: #fff;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 22px;
      border: 0 solid #bbb;
      border-radius: 20px;
      transition: all 0.3s ease;
    }
    > input:checked + label {
      > span:nth-child(1) {
        margin-left: 0;
      }
      > span:nth-child(2) {
        right: 0px;
      }
    }

    @media screen and (max-width: 991px) {
      transform: scale(0.9);
    }
    @media screen and (max-width: 767px) {
      transform: scale(0.825);
    }
    @media screen and (max-width: 575px) {
      transform: scale(0.75);
    }
  }
`;
